import { render, staticRenderFns } from "./AllDocumentDotMenuComponent.vue?vue&type=template&id=4116d345&scoped=true&"
import script from "./AllDocumentDotMenuComponent.vue?vue&type=script&lang=js&"
export * from "./AllDocumentDotMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./AllDocumentDotMenuComponent.vue?vue&type=style&index=0&id=4116d345&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4116d345",
  null
  
)

export default component.exports